/**
 * 任务调度设置接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProductManageService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;


   constructor(
     private http: SwHttpClientService
   ) {
   }

  //#region scheduleTask 产品设置接口


  /**
   * 查询产品列表
   * @param param
   * @returns {Observable<any>}
   */
  getProductList(param) {
    const url = this.prefix + 'product/queryProductPageList';
    return this.http.Post(url, param);
  }

  /**
   * 删除产品
   *
   * @param param
   */
  deleteProductById(param) {
    const url = this.prefix + 'product/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
   * 查看产品信息
   *
   * @param param
   */
  getProductInfo(param) {
    const url = this.prefix + 'product/queryById';
    return this.http.Post(url, param);
  }

  /**
   * 添加产品
   *
   * @param param
   */
  saveProduct(param) {
    const url = this.prefix + 'product/saveProduct';
    return this.http.Post(url, param);
  }

  /**
   * 修改产品
   *
   * @param param
   */
  updateProduct(param) {
    const url = this.prefix + 'product/updateById';
    return this.http.Post(url, param);
  }

    /**
   * 产品上下架
   *
   * @param param
   */
     updateProductStatus(param) {
      const url = this.prefix + 'product/updateProductStatus'+param;
      return this.http.Get(url);
    }

  //#endregion

}
